var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { staticClass: "px-0", attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c("header-programa", {
                attrs: { programa: _vm.obtenerProgramaFixed },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.institucionesDelPrograma.length > 1
        ? _c(
            "b-row",
            { staticClass: "mt-3" },
            [
              _c(
                "b-col",
                { attrs: { "align-v": "end" } },
                [
                  _c("b-form-input", {
                    attrs: {
                      placeholder: _vm.$t(
                        "apeironGwApp.institucionesF1Snp.acciones.buscar"
                      ),
                    },
                    on: {
                      keyup: function ($event) {
                        return _vm.buscarEnInstituciones()
                      },
                    },
                    model: {
                      value: _vm.filtroInstituciones,
                      callback: function ($$v) {
                        _vm.filtroInstituciones = $$v
                      },
                      expression: "filtroInstituciones",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-3" },
        [
          _c(
            "b-col",
            { staticClass: "py-2 area-responsive area-responsive-listado" },
            [
              _vm._l(_vm.institucionesFiltradas, function (institucion) {
                return _c(
                  "b-row",
                  { key: institucion.id },
                  [
                    _c(
                      "b-col",
                      [
                        _c(
                          "b-card",
                          {
                            staticClass: "mt-3",
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "header",
                                  fn: function () {
                                    return [
                                      _c(
                                        "h4",
                                        { staticClass: "mb-0" },
                                        [
                                          _c("span", {
                                            domProps: {
                                              textContent: _vm._s(
                                                institucion.nombreInstitucion
                                              ),
                                            },
                                          }),
                                          _vm._v(" "),
                                          institucion.postulante
                                            ? _c(
                                                "b-badge",
                                                {
                                                  attrs: { variant: "success" },
                                                },
                                                [
                                                  _c("span", {
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "apeironGwApp.institucionesF1Snp.mensajes.postulante"
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "my-1" },
                              [
                                _c("b-col", [
                                  _c("strong", [
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm
                                            .$t(
                                              "apeironGwApp.institucionesF1Snp.campos.noDeRegistro"
                                            )
                                            .toString() + ":"
                                        ),
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(institucion.reniecyt),
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("b-col", [
                                  _c("strong", [
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm
                                            .$t(
                                              "apeironGwApp.institucionesF1Snp.campos.claveInstitucion"
                                            )
                                            .toString() + ":"
                                        ),
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        institucion.claveInstitucion
                                      ),
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("b-col", [
                                  _c("strong", [
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm
                                            .$t(
                                              "apeironGwApp.institucionesF1Snp.campos.pais"
                                            )
                                            .toString() + ":"
                                        ),
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(institucion.pais),
                                    },
                                  }),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              { staticClass: "my-1" },
                              [
                                _c("b-col", [
                                  _c("strong", [
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm
                                            .$t(
                                              "apeironGwApp.institucionesF1Snp.campos.entidadFederativa"
                                            )
                                            .toString() + ":"
                                        ),
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        institucion.entidadFederativa
                                      ),
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("b-col", [
                                  _c("strong", [
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm
                                            .$t(
                                              "apeironGwApp.institucionesF1Snp.campos.municipio"
                                            )
                                            .toString() + ":"
                                        ),
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        institucion.municipio
                                      ),
                                    },
                                  }),
                                ]),
                                _vm._v(" "),
                                _c("b-col", [
                                  _c("strong", [
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm
                                            .$t(
                                              "apeironGwApp.institucionesF1Snp.campos.sector"
                                            )
                                            .toString() + ":"
                                        ),
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(institucion.sector),
                                    },
                                  }),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass:
                                      "mt-2 area-responsive area-responsive-tabla",
                                  },
                                  [
                                    _c("b-table", {
                                      attrs: {
                                        striped: "",
                                        hover: "",
                                        bordered: "",
                                        small: "",
                                        "thead-class": "custom-header",
                                        items: institucion.sedes,
                                        fields: _vm.fieldsSedes,
                                        "show-empty": "",
                                        "empty-text": _vm.$t(
                                          "apeironGwApp.institucionesF1Snp.mensajes.sinRegistros"
                                        ),
                                        "per-page": _vm.perPage,
                                        "current-page": _vm.currentPage,
                                        "sticky-header": "true",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "cell(postulante)",
                                            fn: function (data) {
                                              return [
                                                data.item.postulante
                                                  ? _c(
                                                      "b-badge",
                                                      {
                                                        attrs: {
                                                          variant: "success",
                                                        },
                                                      },
                                                      [
                                                        _c("span", {
                                                          domProps: {
                                                            textContent: _vm._s(
                                                              _vm.$t(
                                                                "apeironGwApp.institucionesF1Snp.mensajes.postulante"
                                                              )
                                                            ),
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                          {
                                            key: "cell(acciones)",
                                            fn: function (data) {
                                              return [
                                                !data.item.postulante &&
                                                !_vm.readOnly
                                                  ? _c(
                                                      "b-button",
                                                      {
                                                        directives: [
                                                          {
                                                            name: "b-tooltip",
                                                            rawName:
                                                              "v-b-tooltip.hover.left",
                                                            value: _vm.$t(
                                                              "apeironGwApp.institucionesF1Snp.acciones.eliminar"
                                                            ),
                                                            expression:
                                                              "$t('apeironGwApp.institucionesF1Snp.acciones.eliminar')",
                                                            modifiers: {
                                                              hover: true,
                                                              left: true,
                                                            },
                                                          },
                                                        ],
                                                        attrs: {
                                                          variant: "outline",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.mostrarModalEliminarInstitucion(
                                                              institucion,
                                                              data.item
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("b-icon", {
                                                          attrs: {
                                                            icon: "trash",
                                                            variant: "primary",
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  [
                                    _c("b-pagination", {
                                      attrs: {
                                        "total-rows":
                                          institucion?.sedes?.length ?? 0,
                                        "per-page": _vm.perPage,
                                        "aria-controls": "my-table",
                                        size: "sm",
                                      },
                                      model: {
                                        value: _vm.currentPage,
                                        callback: function ($$v) {
                                          _vm.currentPage = $$v
                                        },
                                        expression: "currentPage",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              !_vm.institucionesFiltradas.length
                ? _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-alert",
                            { attrs: { variant: "info", show: "" } },
                            [
                              _c(
                                "b-row",
                                [
                                  _c("b-col", [
                                    _c("strong", [
                                      _c("span", {
                                        domProps: {
                                          textContent: _vm._s(
                                            _vm.$t(
                                              "apeironGwApp.institucionesF1Snp.mensajes.sinInstituciones"
                                            )
                                          ),
                                        },
                                      }),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-row",
                                [
                                  _c("b-col", [
                                    _c("span", {
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.$t(
                                            "apeironGwApp.institucionesF1Snp.mensajes.indicacionGenerarNueva"
                                          )
                                        ),
                                      },
                                    }),
                                  ]),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              !_vm.caracteristica.cveCaracteristica
                                ? _c(
                                    "b-row",
                                    [
                                      _c("b-col", [
                                        _c("span", {
                                          staticClass: "fnt-color-7421",
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.$t(
                                                "apeironGwApp.institucionesF1Snp.mensajes.dependenciaDeEdicionAPrograma"
                                              )
                                            ),
                                          },
                                        }),
                                      ]),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-1" },
        [
          _c("b-col", { staticClass: "text-right" }, [
            _c("span", {
              domProps: {
                textContent: _vm._s(_vm.institucionesFiltradas.length),
              },
            }),
            _vm._v(" "),
            _c("span", {
              domProps: {
                textContent: _vm._s(
                  _vm.$t("apeironGwApp.institucionesF1Snp.mensajes.registros")
                ),
              },
            }),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _vm.mostrarAccionNueva && !_vm.readOnly
        ? _c(
            "b-row",
            { staticClass: "mt-1" },
            [
              _c(
                "b-col",
                { staticClass: "text-right" },
                [
                  _c("instituciones-registrar-f1-snp", {
                    attrs: {
                      solicitud: _vm.solicitud,
                      solucion: _vm.solucion,
                      id: "reg-inst",
                    },
                    on: {
                      guardado: function ($event) {
                        return _vm.manejaSeleccionInstitucion($event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-modal",
                {
                  attrs: { id: "modal-eliminar-inst-snp", size: "md" },
                  scopedSlots: _vm._u([
                    {
                      key: "modal-title",
                      fn: function () {
                        return [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.institucionesF1Snp.mensajes.tituloEliminar"
                                )
                              ),
                            },
                          }),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "modal-footer",
                      fn: function () {
                        return [
                          _c(
                            "b-button",
                            {
                              staticClass: "mt-3",
                              attrs: { variant: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.eliminarInstitucion()
                                },
                              },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.institucionesF1Snp.acciones.eliminar"
                                    )
                                  ),
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-button",
                            {
                              staticClass: "mt-3",
                              attrs: { variant: "secondary" },
                              on: {
                                click: function ($event) {
                                  _vm.mostrarModalEliminar = false
                                },
                              },
                            },
                            [
                              _c("span", {
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.$t(
                                      "apeironGwApp.institucionesF1Snp.acciones.cerrar"
                                    )
                                  ),
                                },
                              }),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                  model: {
                    value: _vm.mostrarModalEliminar,
                    callback: function ($$v) {
                      _vm.mostrarModalEliminar = $$v
                    },
                    expression: "mostrarModalEliminar",
                  },
                },
                [
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("b-col", { staticClass: "d-block text-center" }, [
                        _c("h3", {
                          domProps: {
                            textContent: _vm._s(
                              _vm.$t(
                                "apeironGwApp.institucionesF1Snp.mensajes.detalleEliminar"
                              )
                            ),
                          },
                        }),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }